module.exports = __webpack_public_path__ + "850bd05b1e401ad5407ad6677db3c4d9.svg";